module.exports = __webpack_public_path__ + "20e75f9311d525993dd18437adff0bf1.jpg";